module.exports = __webpack_public_path__ + "media/images/svg/jobs/hourglass-9776bc565143849dddc3ed48ef67a5b2.svg";